import { useTranslation } from 'react-i18next';

import ReportsAccordion from '../General/ReportsAccordion';

import EncounterElement from './EncounterElement';

import { Encounter } from 'api/periodReports/type';

const EncounterAccordion: React.FC<{ encounters: Encounter[] }> = ({ encounters }) => {
  const { t } = useTranslation();
  return (
    <ReportsAccordion
      title={t('EcnounterList.accordion.accordion-title')}
      noDataText={t('EcnounterList.accordion.accordion-inner.no-data')}
      data={encounters}
      mapElement={(data: Encounter) => <EncounterElement encounter={data} />}
    />
  );
};

export default EncounterAccordion;
